module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard@3x-ba1ebea9db57032016e842c2f3080cbd.png";